import Repository from './Repository';

class ExampleRepository extends Repository {
  async exampleRequest() {
    return await this.request.get(this.services.exampleService);
  }
}

export default ExampleRepository;
